"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploaderId = void 0;
var UploaderId;
(function (UploaderId) {
    UploaderId["VIDEO_MAIN"] = "main";
    UploaderId["VIDEO_COVER"] = "cover";
    UploaderId["VIDEO_TRAILER"] = "trailer";
    UploaderId["VIDEO_POSTER"] = "poster";
    UploaderId["CHANNEL_COVER"] = "channel-cover";
    UploaderId["EMBED_LOGO"] = "embed-logo";
    UploaderId["VIDEO_CARD_IMAGE"] = "video-card-image";
})(UploaderId = exports.UploaderId || (exports.UploaderId = {}));
//# sourceMappingURL=uploader-id.js.map